import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {VisionStepPerimeter} from '../message/VisionStepPerimeter';
import {VisionStepPerimeterCriteria} from './VisionStepPerimeterCriteria';
import {VisionStepPerimeterScenario} from './VisionStepPerimeterScenario';

export class VisionStepPerimeterWrapper extends BaseWrapper<VisionStepPerimeter, VisionStepPerimeterCriteria, VisionStepPerimeterScenario>  {}

